var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { resourceNames } from "../../../constants/accountResourceNames";
var messages = defineMessages({
    msg_0: {
        id: "bet_history.errors.internal_error",
        defaultMessage: "Internal server error"
    },
    msg_1: {
        id: "bet_history.errors.insufficient_funds",
        defaultMessage: "Недостаточно средств на балансе"
    },
    msg_2: {
        id: "bet_history.errors.factor_changed",
        defaultMessage: "Stake is not accepted"
    },
    msg_3: {
        id: "bet_history.errors.account_locked",
        defaultMessage: "Account is locked"
    },
    msg_6: {
        id: "bet_history.errors.min_stake_amount",
        defaultMessage: "Min stake amount {minAmount} {currency}"
    },
    msg_7: {
        id: "bet_history.errors.max_win_amount",
        defaultMessage: "Max {minAmount} {currency}"
    },
    msg_12: {
        id: "bet_history.errors.max_stake",
        defaultMessage: "Max stake amount {amount} {currency}"
    },
    msg_13: {
        id: "coupon.not_possible_stake",
        defaultMessage: "Данная ставка невозможна"
    },
    coupon_bet_not_accepted: {
        id: "coupon.bet_not_accepted",
        defaultMessage: "Ставка отклонена"
    },
    coupon_bet_not_accepted_by_terms: {
        id: "coupon.bet_not_accepted_by_terms",
        defaultMessage: "Ставка не принята, не соблюдены условия промокода"
    },
    "-1": {
        id: "coupon_bet_promocode_not_found1",
        defaultMessage: "Фрибет не найден"
    },
    "-21": {
        id: "coupon_bet_for_get_freebet_fill_balance21",
        defaultMessage: "Для получения фрибета необходимо пополнить счет на сумму {amount} {currency}"
    },
    "-22": {
        id: "coupon_bet_for_using_freebet_make_stake_more22",
        defaultMessage: "Для использования фрибета необходимо сделать ставку на сумму от {amount} {currency}"
    },
    "-24": {
        id: "coupon_bet_for_using_freebet_necessary_auth24",
        defaultMessage: "Для использования данного фрибета необходимо подтвердить свою личность. Просьба обратиться в онлайн чат службы поддержки."
    },
    "-32": {
        id: "coupon_bet_for_stake_type32",
        defaultMessage: "Применимо к ставке типа: {amount}"
    },
    "-37": {
        id: "coupon_bet_not_for_stake_type37",
        defaultMessage: "Не применимо к данному матчу"
    },
    "-38": {
        id: "coupon_bet_not_for_the_league38",
        defaultMessage: "Не применимо к данной лиге"
    },
    "-39": {
        id: "coupon_bet_freebet_not_for_sport39",
        defaultMessage: "Фрибет недоступен для данного спорта"
    },
    "-33": {
        id: "coupon_bet_min_coef_should33",
        defaultMessage: "Минимальный коэфицент должен быть - {amount}"
    },
    "-35": {
        id: "coupon_for_using_freebet_nesessarry_choose_more35",
        defaultMessage: "Для использования фрибета необходимо выбрать не менее {amount} событий."
    },
    "-2": {
        id: "coupon_bet_coef_stakes_changed2",
        defaultMessage: "Коэффициент ставки был изменен"
    },
    "-23": {
        id: "coupon_bet_nessary_should_more23",
        defaultMessage: "Сумма ставок должна превышать {amount} USD"
    },
    "-31": {
        id: "coupon_bet_validation_is_not_accept31",
        defaultMessage: "Фрибет доступен только в {amount}"
    },
    "-34": {
        id: "coupon_bet_validation_is_not_accept_by_minCoef34",
        defaultMessage: "Коэффициент не должен превышать {amount}"
    },
    "-36": {
        id: "coupon_bet_freebet_sum_not_equal_sum_stake36",
        defaultMessage: "Сумма фрибета меньше/больше суммы ставки"
    },
    single: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар'
    },
    express: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс'
    },
    system: {
        id: 'bet_type.system_2',
        defaultMessage: 'Система'
    },
    msg_minus_19: {
        id: "bet_history.errors.max_allowed_stake",
        defaultMessage: "Максимально допустимая сумма ставки: {limit} {currency}"
    }
});
// const PromoCodeErrors = [
//   -21,
//   -22,
//   -23,
//   -24,
//   -31,
//   -32,
//   -33,
//   -34,
//   -35,
//   -36,
//   -37,
//   -38
// ];
var QuickBetError = function (props) {
    var getStakeTypesInFormat = function (arr) {
        var stakeTypes = {
            1: props.intl.formatMessage(messages['single']),
            2: props.intl.formatMessage(messages['express']),
            3: props.intl.formatMessage(messages['system'])
        };
        return arr.map(function (item) {
            return stakeTypes[item];
        }).join('');
    };
    switch (props.errorCode) {
        case 6:
            return (_jsx("div", __assign({ className: "control__error" }, { children: _jsx("div", __assign({ className: "sub" }, { children: _jsx(FormattedMessage, __assign({}, messages["msg_6"], { values: {
                            minAmount: props.minBetAmount,
                            currency: resourceNames[props.accountResourceId]
                        } })) })) })));
        case 12:
            return (_jsx("div", __assign({ className: "control__error" }, { children: _jsx("div", __assign({ className: "sub" }, { children: _jsx(FormattedMessage, __assign({}, messages["msg_12"], { values: {
                            amount: props.alternativeStake,
                            currency: resourceNames[props.accountResourceId]
                        } })) })) })));
        case 13:
            return (_jsx("div", __assign({ className: "control__error" }, { children: _jsx("div", __assign({ className: "sub" }, { children: _jsx(FormattedMessage, __assign({}, messages["msg_13"])) })) })));
        case 111:
            return (_jsx("div", __assign({ className: "control__error" }, { children: _jsx("div", __assign({ className: "title" }, { children: _jsx(FormattedMessage, __assign({}, messages["msg_1"])) })) })));
        default:
    }
    if (props.freebetErrors) {
        return (_jsx("div", __assign({ className: "control__error" }, { children: props.freebetErrors.map(function (err) {
                var hasAdditionalValue = err.AdditionalValue;
                return (_jsx("div", __assign({ className: "control__error" }, { children: _jsx("div", __assign({ className: "title" }, { children: hasAdditionalValue ? (_jsx(FormattedMessage, __assign({}, messages[err.ErrorCode], { values: {
                                amount: Array.isArray(err.AdditionalValue)
                                    ? getStakeTypesInFormat(err.AdditionalValue)
                                    : err.AdditionalValue,
                                currency: resourceNames[props.accountResourceId]
                            } }))) : (_jsx(FormattedMessage, __assign({}, messages[err.ErrorCode]))) })) }), err.ErrorCode));
            }) })));
    }
    var msgKey = "msg_" + props.errorCode;
    var errorMsg = messages[msgKey];
    var resourceId = props.accountResourceId;
    var currency = resourceNames[resourceId];
    var msg = props.resolution ? props.resolution : "";
    if (props.maxWinAmount) {
        msg = (_jsx(FormattedMessage, __assign({}, errorMsg, { values: { currency: currency, minAmount: props.maxWinAmount } })));
    }
    var showMsg = props.errorCode !== 1;
    console.log('props', props);
    return (_jsxs("div", __assign({ className: "control__error" }, { children: [props.maxWinAmount === undefined && props.minBetAmount === undefined && (_jsx("div", __assign({ className: "title" }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_bet_not_accepted)) }))), showMsg && _jsx("div", __assign({ className: "sub" }, { children: msg })), props.errorCode === 10 && (_jsx("div", __assign({ className: "sub" }, { children: "\u041A\u0440\u0443\u043F\u043D\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B" }))), props.errorCode === -19 && props.limit > 0 && (_jsx("div", __assign({ className: "sub" }, { children: _jsx(FormattedMessage, __assign({}, messages["msg_minus_19"], { values: {
                        limit: props.limit,
                        currency: resourceNames[props.accountResourceId]
                    } })) })))] })));
};
QuickBetError.propTypes = {
    errorCode: PropTypes.any,
    resolution: PropTypes.any
};
export default injectIntl(QuickBetError);



// WEBPACK FOOTER //
// ./src/components/coupon/quickbet/QuickBetError.jsx